export const UPDATE_REGION_FILTER = "@@regionFilter/UPDATE_REGION_FILTER";

export const updateRegionFilter = excludedTld => {
  return {
    type: UPDATE_REGION_FILTER,
    excludedTld
  };
};
